import Api from 'app/services/Api'

/**
 * place a bid
 */
export const placeBid = ({ auctionId, price }: PlaceBidDTO): Promise<void> =>
  Api.post(`/api/v1/users/buyers/bids`, {
    data: {
      buyer_bid: {
        auction_id: auctionId,
        price
      }
    }
  })

/**
 * set a auto bid
 */
export const setAutoBid = ({ auctionId, price }: SetMaxBidDTO): Promise<void> =>
  Api.post('/api/v1/users/buyers/autobids', {
    data: {
      buyer_autobid: {
        auction_id: auctionId,
        price
      }
    }
  })

/**
 * delete a auto bid
 */
export const deleteAutoBid = (maxBidId: string): Promise<void> =>
  Api.del(`/api/v1/users/buyers/autobids/${maxBidId}`)

/**
 * get last 5 bids
 */
export const getLastBids = (auctionId: number): Promise<PublicBidHistory> =>
  Api.get(`/api/v1/bids`, {
    deserialize: true,
    params: {
      auction_id: auctionId
    }
  })

/**
 * get all buyer auctions
 */
export const getBuyerAuctions = (
  params: PaginationParams
): Promise<PaginationAuctionModel> =>
  Api.get(`/api/v1/users/buyers/auctions`, {
    deserialize: true,
    params
  })

/**
 * get all seller auctions
 */
export const getSellerAuctions = (
  params: PaginationParams
): Promise<PaginationAuctionModel> =>
  Api.get(`/api/v1/users/sellers/auctions`, {
    deserialize: true,
    params
  })

/**
 * get buyer bids
 */
export const getBuyerBids = (params: BuyerBidsParams): Promise<Bid[]> =>
  Api.get(`/api/v1/users/buyers/bids`, {
    deserialize: true,
    params
  })

/**
 * get seller bids
 */
export const getSellerBids = (params: SellerBidsParams): Promise<Bid[]> =>
  Api.get(`/api/v1/users/sellers/bids`, {
    deserialize: true,
    params
  })

/**
 * read bids
 */
export const readBids = ({ auction_id }: BidReadDTO): Promise<void> =>
  Api.put(`/api/v1/users/sellers/bids/${auction_id}`)

/**
 * get all auctionWatchLists
 */
export const getAuctionWatchLists = (
  params: PaginationParams
): Promise<PaginationWatchListModel> =>
  Api.get(`/api/v1/users/buyers/auction_watchlists`, {
    deserialize: true,
    params
  })

/**
 * add auction to watchList
 */
export const addAuctionToWatchList = (auctionId: number): Promise<void> =>
  Api.post(`/api/v1/users/buyers/auction_watchlists`, {
    data: {
      auction_watchlist: {
        auction_id: auctionId
      }
    }
  })

/**
 * delete auction from watchList
 */
export const deleteAuctionFromWatchList = (auctionId: string): Promise<void> =>
  Api.del(`/api/v1/users/buyers/auction_watchlists/${auctionId}`)
